"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueLanguages = [
    'ASL',
    'AMERICAN SIGN LANG',
    'AMERICAN SIGN LANGUAGE',
    'ARABIC',
    'CHINESE',
    'FRENCH',
    'GERMAN',
    'HEBREW',
    'HINDI',
    'ITALIAN',
    'JAPANESE',
    'KOREAN',
    'LATIN',
    'OTHER',
    'PORTUGUESE',
    'RUSSIAN',
    'RUSSIAN',
    'SPANISH',
    'SPANISH FOR SPAN SPEAKERS',
    'TURKISH',
    'VIETNAMESE'
];
//# sourceMappingURL=uniqueLanguages.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/uniqueLanguages.js
// module id = 459
// module chunks = 22